import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LoadingState {
  isLoading: boolean;
  error: string | null;
  message: string | null;
}

const initialState: LoadingState = {
  isLoading: false,
  error: null,
  message: null,
};

export const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setMessage: (state, action: PayloadAction<string | null>) => {
      state.message = action.payload;
    },
    clearState: state => {
      state.isLoading = false;
      state.error = null;
      state.message = null;
    },
  },
});

export const { setLoading, setError, setMessage, clearState } =
  loadingSlice.actions;
export default loadingSlice.reducer;
